import { escapeHtml } from "./booking-utils";

export interface PaymentMarkupResult {
  html: string;
  refreshable: boolean;
}

export interface RecurringPaymentMarkupInput {
  state: string;
  occurrenceCount: number;
  priceTooltip: string;
  checkoutUrl?: string | null;
  paymentRefreshing: boolean;
}

function refreshButton(paymentRefreshing: boolean): string {
  const refreshLabel = paymentRefreshing ? "Consultando…" : "Ya pagué · actualizar";
  const refreshState = paymentRefreshing ? " disabled aria-busy=\"true\"" : "";
  return `<button type="button" class="primary-button" data-action="payment-refresh"${refreshState}>${refreshLabel}</button>`;
}

export function renderRecurringPaymentMarkup(input: RecurringPaymentMarkupInput): PaymentMarkupResult {
  if (input.state === "paid") {
    return {
      html: `<div class="payment-link"><strong>Pago aprobado</strong><span>Las ${input.occurrenceCount} ocurrencias de la serie quedaron confirmadas.</span><span>Total: ${input.priceTooltip}</span></div>`,
      refreshable: false
    };
  }
  if (input.state === "failed") {
    return {
      html: `<div class="payment-link failed"><strong>El pago no fue aprobado</strong><span>La serie se canceló y, si corresponde, quedó registrada una solicitud de devolución pendiente de aprobación administrativa.</span></div>${refreshButton(input.paymentRefreshing)}`,
      refreshable: true
    };
  }
  return {
    html: `<div class="payment-link"><strong>Pago único de la serie</strong><span>Se cobrará ${input.priceTooltip} una sola vez por todas las fechas.</span>${input.checkoutUrl ? `<a href="${escapeHtml(input.checkoutUrl)}" target="_blank" rel="noreferrer">Abrir Mercado Pago</a>` : ""}<small>Después de pagar, esta pantalla actualizará el estado. Las citas permanecen pendientes hasta la aprobación del webhook.</small></div>${refreshButton(input.paymentRefreshing)}`,
    refreshable: true
  };
}

export interface BookingPaymentMarkupInput {
  paymentStatus: string;
  linkStatus: string;
  bookingStatus: string;
  paymentRefreshing: boolean;
  checkoutUrl?: string | null;
  priceTooltip: string;
}

export function renderBookingPaymentMarkup(input: BookingPaymentMarkupInput): PaymentMarkupResult {
  if (input.paymentStatus === "paid" && input.bookingStatus === "confirmed") {
    return {
      html: '<div class="payment-link"><strong>Pago aprobado</strong><span>Tu reserva quedó confirmada.</span></div>',
      refreshable: false
    };
  }
  if (input.bookingStatus === "cancelled" || ["failed", "cancelled", "expired"].includes(input.paymentStatus) || ["cancelled", "expired"].includes(input.linkStatus)) {
    const message = input.bookingStatus === "cancelled" && input.paymentStatus === "paid"
      ? "El pago llegó cuando el horario ya no estaba retenido. La devolución quedó registrada para revisión administrativa."
      : "El enlace de pago ya no está disponible o el pago fue rechazado.";
    return {
      html: `<div class="payment-link failed"><strong>No se pudo confirmar la reserva</strong><span>${message}</span></div>${refreshButton(input.paymentRefreshing)}`,
      refreshable: true
    };
  }
  return {
    html: `<div class="payment-link"><strong>Pago único de la reserva</strong><span>Se cobrará ${input.priceTooltip} una sola vez.</span>${input.checkoutUrl ? `<a href="${escapeHtml(input.checkoutUrl)}" target="_blank" rel="noreferrer">Abrir Mercado Pago</a>` : "<small>Estamos preparando el enlace de pago.</small>"}<small>La reserva queda pendiente hasta que Mercado Pago apruebe el cobro y el webhook confirme el horario.</small></div>${refreshButton(input.paymentRefreshing)}`,
    refreshable: true
  };
}
